<button
  class="clear-filter-btn"
  [disabled]="!isButtonEnabled"
  (click)="clearFilters()"
  matTooltip="Clear Filters"
  matTooltipPosition="above"
>
  <i class="bi bi-funnel-fill"></i>
</button>
